import React from 'react';

import { flagStyles } from '../settings';

const SvgGR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2088px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGR;
